import styled from 'styled-components';
import { media } from 'styles/media';
import { legacyTheme } from 'styles/theme';

export const StyledDividedContainer = styled.div`
  display: flex;
  width: 100%;
  height: 100%;

  ${media.lessThan('md')`
    flex-direction: column-reverse;
    justify-content: flex-end;
    background-color: ${legacyTheme.colors.cream};
  `}
`;
